import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import MemberItem from '../ManageMember/MemberItem';
import SvgIcon from '../common/base/SvgIcon.vue';
import SearchIcon from '../common/icons/SearchIcon.vue';
import ApplyTipsIcon from '../common/icons/ApplyTipsIcon.vue';
import Dialog from '../common/base/Dialog';
import { useRoomStore } from '../../stores/room';
import useIndex from './useIndexHooks';
import TuiButton from '../common/base/Button.vue';
import ArrowUpIcon from '../common/icons/ArrowUpIcon.vue';
import '../../directives/vClickOutside';
import { USERS_STATUS } from '../../constants/room';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  setup(__props) {

const roomStore = useRoomStore();

const { applyToAnchorList, isGeneralUser } = storeToRefs(roomStore);

const {
  t,
  searchText,
  showApplyUserList,
  showManageAllUserDialog,
  dialogTitle,
  dialogContent,
  toggleManageAllMember,
  doToggleManageAllMember,
  ManageControlType,
  handleToggleStaged,
  applyToAnchorUserContent,
  audioManageInfo,
  videoManageInfo,
  toggleClickMoreBtn,
  showMoreControl,
  moreControlList,
  userStatusList,
  currentActiveTabName,
  filteredUserStatusList,
  handleCallAllInvitee,
} = useIndex();

const handleShowMoreControl = () => {
  if (showMoreControl.value) {
    showMoreControl.value = false;
  }
};

return { __sfc: true,roomStore, applyToAnchorList, isGeneralUser, t, searchText, showApplyUserList, showManageAllUserDialog, dialogTitle, dialogContent, toggleManageAllMember, doToggleManageAllMember, ManageControlType, handleToggleStaged, applyToAnchorUserContent, audioManageInfo, videoManageInfo, toggleClickMoreBtn, showMoreControl, moreControlList, userStatusList, currentActiveTabName, filteredUserStatusList, handleCallAllInvitee, handleShowMoreControl, MemberItem, SvgIcon, SearchIcon, ApplyTipsIcon, Dialog, TuiButton, ArrowUpIcon, USERS_STATUS }
}

})